module.exports = __webpack_public_path__ + "img/lengqueta.9e89b913.png";